import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import ParagraphTag from "../../reusebale/Paragraph";
import TutorialPopup from "../../popup/createTutorial";
import BaseUrl from "../../../constants/BaseUrl";
import NoData from "../../reusebale/noData";
import { useSelector } from "react-redux";

const TutorialSection = ({ onViewCreate, searchTerm }) => {
  const [isShowPopup, setShowPopup] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [deletingId, setDeletingId] = useState(null);
  const { loginSuccess } = useSelector((state) => state.auth);

  const handleOpen = () => {
    setShowPopup(true);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const GetAllTutorials = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/tutorials/getAllTutorials?page=1&limit=100`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setData(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllTutorials();
  }, []);

  // Filter tutorials based on search term
  useEffect(() => {
    if (!searchTerm || searchTerm.trim() === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((tutorial) => {
        const title = tutorial?.title?.toLowerCase() || "";
        return title.includes(searchTerm.toLowerCase());
      });
      setFilteredData(filtered);
    }
  }, [data, searchTerm]);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const deleteTutorial = async (id) => {
    if (!window.confirm("Are you sure you want to delete this tutorial?")) {
      return;
    }

    setDeletingId(id);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${BaseUrl}api/tutorials/deleteTutorial/${id}`,
        requestOptions
      );
      const result = await response.json();

      if (result.status === "Success") {
        // Remove the deleted tutorial from the data
        setData((prevData) =>
          prevData.filter((tutorial) => tutorial._id !== id)
        );
      } else {
        alert("Failed to delete tutorial");
      }
    } catch (error) {
      console.error("Error deleting tutorial:", error);
      alert("Error deleting tutorial");
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="h-full pt-4">
      <div className="bg-white w-full rounded-lg h-[95%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex justify-between items-center h-[12%]">
            <div className="w-full flex justify-end">
              <button
                className="w-[20%] bg-themeColor rounded-md flex items-center justify-center py-2"
                onClick={onViewCreate}
              >
                <Plus color="#FFFFFF" size={15} />
                <ParagraphTag
                  content="Create New"
                  classes="text-white font-popinsSemiBold text-xs pl-2"
                  onTrigger={handleOpen}
                />
              </button>
            </div>
          </div>
          <div
            className="overflow-y-auto w-full h-[85%] panelScroll pt-2 flex flex-wrap"
            id="gk-cards"
            style={{ maxHeight: "calc(100% - 2%)" }} // Ensures scrolling within the remaining space
          >
            {filteredData?.map((item, i) => (
              <div className="w-[32%] mr-[2%] pt-3 relative" key={i}>
                <div className="overflow-hidden relative group">
                  <iframe
                    className="w-full h-56 rounded-2xl shadow-lg"
                    src={
                      item?.link.replace("watch?v=", "embed/").split("&")[0] +
                      "?rel=0&modestbranding=1"
                    }
                    title={item.title}
                    allowFullScreen
                  ></iframe>
                  <button
                    onClick={() => deleteTutorial(item._id)}
                    disabled={deletingId === item._id}
                    className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 disabled:opacity-50"
                  >
                    {deletingId === item._id ? (
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <Trash2 size={16} />
                    )}
                  </button>
                </div>
                <ParagraphTag
                  content={item?.title}
                  classes="text-dark font-popinsRegular text-md flex justify-center items-center my-2"
                />
              </div>
            ))}
            {filteredData.length === 0 && data.length > 0 && (
              <div className="w-full mt-5 text-center">
                <p className="text-gray-500 font-popinsRegular">
                  No tutorials found matching your search.
                </p>
              </div>
            )}
            {data.length === 0 && (
              <div className="w-full mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
      {isShowPopup && (
        <TutorialPopup
          refreshList={() => GetAllTutorials()}
          onBack={handleClose}
        />
      )}
    </div>
  );
};

export default TutorialSection;
